declare var process: any;
declare var require: any;

import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Icon, Tooltip, Permission } from '../';
import { openNavigation, closeNavigation } from '../../redux/actions/app';
import { switchAccount } from '../../redux/actions/auth';

const logo = require('../../assets/logo-white.svg');

interface Props {
  app: any;
  auth: any;
  dispatch: Function;
}

class Topbar extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.renderCurrentAccount = this.renderCurrentAccount.bind(this);
    this.renderAccountSelector = this.renderAccountSelector.bind(this);
  }

  /**
   * Render the current account name
   */
  renderCurrentAccount() {
    const currentAccount = this.props.auth.user.accounts.filter(
      (account) => account.user_account.is_default,
    )[0];

    return (
      <div>
        <small>{currentAccount.name}</small>
      </div>
    );
  }

  /**
   * Render the account selection section
   */
  renderAccountSelector(showIcon: boolean = false) {
    const accounts = this.props.auth.user.accounts;

    if (!accounts.length) {
      return null;
    }

    return (
      <span>
        {accounts.map((account) => (
          <a
            key={account.id}
            className={`navbar-item account-selector ${
              account.user_account.is_default ? 'selected' : ''
            }`}
            onClick={() => {
              !account.user_account.is_default &&
                this.props.dispatch(switchAccount(account.id));
            }}
          >
            {showIcon && <Icon icon="building" />} {account.name}
          </a>
        ))}
        <hr className="navbar-divider" />
      </span>
    );
  }

  render() {
    const { app, dispatch, auth } = this.props;
    return (
      <nav className="topbar">
        <div className="container">
          <div className="navbar">
            <div className="navbar-brand">
              <Link className="navbar-item" to="/">
                <img width="100" src={logo} alt={process.env.APP_NAME} />
              </Link>
              <span
                className={`navbar-burger ${
                  app.isNavigationOpen ? 'is-active' : ''
                }`}
                onClick={() => {
                  if (app.isNavigationOpen) {
                    dispatch(closeNavigation());
                  } else {
                    dispatch(openNavigation());
                  }
                }}
              >
                <span />
                <span />
                <span />
              </span>
            </div>
            <div
              className={`navbar-menu ${
                app.isNavigationOpen ? 'is-active' : ''
              }`}
            >
              {auth.isAuthenticated ? (
                <div className="navbar-end">
                  <div className="navbar-item is-hidden-desktop">
                    <div>{auth.user.name}</div>
                  </div>
                  <span className="is-hidden-desktop">
                    {this.renderAccountSelector(true)}
                  </span>
                  <Tooltip text="History" position="bottom">
                    <Link to="/history" className="navbar-item">
                      <Icon icon="calendar" />
                      <span className="is-hidden-desktop">&nbsp;History</span>
                    </Link>
                  </Tooltip>
                  <Tooltip text="Availabilities" position="bottom">
                    <Link to="/availabilities" className="navbar-item">
                      <Icon icon="calendar-plus-o" />
                      <span className="is-hidden-desktop">
                        &nbsp;Availabilities
                      </span>
                    </Link>
                  </Tooltip>
                  <Tooltip text="CRM" position="bottom">
                    <Link to="/dashboard/crm" className="navbar-item">
                      <Icon icon="users" />
                      <span className="is-hidden-desktop">&nbsp;CRM</span>
                    </Link>
                  </Tooltip>
                  <Permission require="MANAGE_PAYMENTS">
                    <Tooltip text="Accounting" position="bottom">
                      <Link to="/dashboard/accounting" className="navbar-item">
                        <Icon icon="credit-card" />
                        <span className="is-hidden-desktop">
                          &nbsp;Accounting
                        </span>
                      </Link>
                    </Tooltip>
                  </Permission>
                  <Tooltip text="Notes" position="bottom">
                    <Link to="/notes" className="navbar-item">
                      <Icon icon="comments" />
                      <span className="is-hidden-desktop">&nbsp;Notes</span>
                    </Link>
                  </Tooltip>
                  <Link
                    to="/settings"
                    className="navbar-item is-hidden-desktop"
                  >
                    <Icon icon="cog" /> Settings
                  </Link>
                  <Link to="/logout" className="navbar-item is-hidden-desktop">
                    <Icon icon="sign-out" /> Logout
                  </Link>
                  <div className="navbar-item has-dropdown is-hoverable is-hidden-touch">
                    <a className="navbar-link">
                      <Icon icon="user" />
                    </a>
                    <div className="navbar-dropdown is-right">
                      <div className="navbar-item">
                        <div>{auth.user.name}</div>
                      </div>
                      <hr className="navbar-divider" />
                      {this.renderAccountSelector()}
                      <Link to="/settings" className="navbar-item">
                        Settings
                      </Link>
                      <Link to="/logout" className="navbar-item">
                        Logout
                      </Link>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.app,
  auth: state.auth,
});

export default connect(mapStateToProps)(Topbar);
